<template>
	<div>
		<div class="vert-padding-sm">
			<div class="inline">
				<label for="address-select" class="sr-only">Address 1</label>
				<div class="fg-line">
					<select class="form-control" id="address-select" v-model="addressType" @change="getAddress">
						<option v-for="option in addressOptions" :value="option.value" v-html="option.label">
						</option>
					</select>
				</div>
			</div>
		</div>

		<div class="container-fluid">
			<div class="row">
				<div class="col-xs-12">
					<div class="form-group fg-line">
						<label for="address1">Address 1</label>
						<input type="text" id="address1" name="address1" class="form-control"
							:readonly="addressDisabled" placeholder="required" v-model="address.address1" />
					</div>
				</div>
				<div class="col-xs-12">
					<div class="form-group fg-line">
						<label for="address2">Address 2</label>
						<input type="text" id="address2" name="address2" class="form-control"
							:readonly="addressDisabled" v-model="address.address2" />
					</div>
				</div>
				<div class="col-xs-12 col-sm-6">
					<div class="form-group fg-line">
						<label for="country_cd">Country</label>
						<select id="country_cd" name="country_cd" class="form-control" :disabled="addressDisabled"
							v-model="address.country_cd" @change="resetState">
							<option value="">Select Country</option>
							<option v-for="country in countries" :value="country.country_cd"
								v-html="country.country_nm"></option>
						</select>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6">
					<div class="form-group fg-line">
						<label for="city">City</label>
						<input type="text" id="city" name="city" class="form-control" :readonly="addressDisabled"
							placeholder="required" v-model="address.city" />
					</div>
				</div>
				<div class="col-xs-12 col-sm-3">
					<div class="form-group fg-line">
						<label for="state_cd">State/Province</label>
						<select id="state_cd" class="form-control" :disabled="addressDisabled || states.length === 0"
							v-model="address.state_cd">
							<option value="">Select State</option>
							<option v-for="state in states" :value="state.state_cd" v-html="state.state_nm"></option>
						</select>
					</div>
				</div>


				<div class="col-xs-12 col-sm-6">
					<div class="form-group fg-line">
						<label for="postal_cd">Postal Code</label>
						<input type="text" id="postal_cd" name="postal_cd" class="form-control"
							:readonly="addressDisabled" placeholder="required" v-model="address.postal_cd" />
					</div>
				</div>
				<div class="col-xs-12 form-group">
					<label class="cursor-pointer">
						<input :checked="address.is_residential" type="checkbox" name="is_residential"
							:readonly="addressDisabled" value="1">
						Address is Residential
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@import '../../../sass/global_variables';

#address-select {
	width: initial;
}

input[name="is_residential"] {
	margin-right: 5px;
}

@media (max-width: $break-xs) {
	#shipping-address-select {
		width: 100%;
	}
}
</style>

<script>
import { sanitizeCounty } from './sanitizeCounty';

export default {
	props: {
		account: null,
		limit: null,
		country_white_list: { default: () => [] }
	},
	data: function () {
		return {
			addressType: 'USER',
			address: {
				address1: '',
				address2: '',
				city: '',
				state_cd: '',
				postal_cd: '',
				county: '',
				country_cd: '',
				is_residential: false,
			},
			addressControl: undefined,
			countries: []
		}
	},
	watch: {
		account: {
			deep: true,
			handler() {
				if (this.addressType === 'ACCOUNT' || this.addressType === 'ACT_SHIP') {
					this.getAddress();
				}
			}
		},

		address: {
			handler() {
				this.$emit('update', this.address);
			},
			deep: true
		},

		addressOptions() {
			let opts = this.addressOptions.map(opt => {
				return opt.value
			});

			if (!opts.includes(this.addressType)) {
				this.addressType = opts[0];
				this.getAddress();
			}
		}
	},
	computed: {
		addressOptions() {
			if (!this.limit) {
				return this.getLimitedOptions(['USER', 'ACCOUNT', 'ACT_SHIP', 'TEMP']);
			} else {
				if (!this.limit.includes(this.addressType)) {
					this.addressType = this.limit[0];
					this.getAddress();
				}

				return this.getLimitedOptions(this.limit);
			}
		},

		addressDisabled() {
			return (this.addressType !== 'TEMP');
		},

		// I warned you about states bro!!!
		states() {
			let country = this.countries.find(country =>
				country.country_cd === this.address.country_cd
			);
			return country ? country.states : [];
		}
	},
	methods: {
		updateAddress() {
			this.$emit('update', this.address);
		},

		getLimitedOptions(options) {
			let returnOptions = [];
			for (let i = 0; i < options.length; i++) {
				switch (options[i]) {
					case 'USER':
						returnOptions.push({ value: 'USER', label: 'My Address' });
						break;
					case 'ACCOUNT':
						if (this.account && this.account.account_nbr) {
							returnOptions.push({ value: 'ACCOUNT', label: 'Account Address' });
						}
						break;
					case 'ACT_SHIP':
						if (this.account && this.account.account_nbr) {
							returnOptions.push({ value: 'ACT_SHIP', label: 'Account Shipping Address' });
						}
						break;
					case 'TEMP':
						returnOptions.push({ value: 'TEMP', label: 'One Time Address' });
				}
			}
			return returnOptions;
		},

		initializeAddressy() {
			let keyEl = document.getElementById('addressy-key');
			if (!keyEl) return;

			let key = keyEl.getAttribute('content');
			if (!key) return;

			let searchCountries = this.countries.map(country => country.country_cd).join(',');
			let config = { key: key, bar: { visible: false }, search: { countries: searchCountries } };

			let fields = [
				{ element: 'address1', field: 'Line1', mode: pca.fieldMode.SEARCH },
				{ element: 'country_cd', field: 'CountryIso2', mode: pca.fieldMode.COUNTRY }
			];

			this.addressControl = new pca.Address(fields, config);
			this.addressControl.listen('populate', this.selectedSearchedAddress);
		},

		selectedSearchedAddress(address, variations) {
			this.address = {
				address1: address.Line1,
				address2: address.Line2,
				city: address.City,
				state_cd: address.ProvinceCode,
				county: sanitizeCounty(address),
				country_cd: address.CountryIso2,
				postal_cd: address.PostalCode,
				is_residential: address.Type === 'Residential' ? 1 : 0
			};
		},

		// Reset state on country change
		resetState() {
			this.address.state_cd = "";
		},

		getAddress(success) {
			if (this.addressType === 'TEMP') {
				this.address = { country_cd: 'US', state_cd: '' };
			} else {
				let params = { addressType: this.addressType };

				if (this.account) {
					params.accountNbr = this.account.account_nbr;
				}
				let request = this.$http.get('/user/address', { params: params });
				request.then(function (addressResponse) {
					if (addressResponse.data) {
						let newAddress = addressResponse.data;
						newAddress.country_cd = newAddress.country_cd ? newAddress.country_cd : 'US';
						this.address = newAddress;
					} else {
						if (typeof success === 'function') success(addressResponse);
					}
				});
			}
		},

		getAllCountries() {
			return this.$http.get('/address/get-all-countries', {
				params: {
					countries: this.country_white_list    // if this empty, it the countries param won't even get sent, pretty cool honestly
				}
			}).then(response => {
				this.countries = response.body;
			}).catch(error => {
				console.log(error);
			});
		}
	},
	mounted: function () {
		this.getAllCountries()
			.then(this.initializeAddressy());

		if ((this.addressType !== 'TEMP')) {
			this.getAddress();
		}
	}
}

</script>



// WEBPACK FOOTER //
// address-picker.vue?7bdea9ba